import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastVariant = 'success' | 'error' | 'info'

export interface Toast {
  id: number
  message: string
  variant: ToastVariant
}

let nextId = 0

/**
 * Lightweight toast notifications. Call `show()` to push a message that
 * auto-dismisses after `durationMs`; rendered by the global <Toast /> component.
 */
export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])

  function show(message: string, variant: ToastVariant = 'success', durationMs = 3000) {
    const id = nextId++
    toasts.value.push({ id, message, variant })
    setTimeout(() => dismiss(id), durationMs)
  }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return { toasts, show, dismiss }
})
